export const DEFAULT_VIDEO_KEYWORDS =
  '懂车帝,汽车,汽车网站,评测,视频,试驾,试乘,汽车视频,新车试驾视频,新车评测,汽车视频车评视频,帝造计划,懂车帝出品'
export const DEFAULT_VIDEO_DESCRIPTION =
  '懂车帝为您提供最新最全的汽车视频信息，包括汽车评测、新车试驾、热点事件评测、汽车保养、车展视频、美女车模视频、汽车碰撞视频、维修视频、漂移视频等精彩内容，看车选车买车就上懂车帝'
export const DEFAULT_ARTICLE_KEYWORDS =
  '最新汽车资讯,最新汽车,汽车资讯,汽车文章,文章,图文,试驾,试乘,帝造计划,懂车帝出品'
export const DEFAULT_ARTICLE_DESCRIPTION =
  '懂车帝是一个汽车资讯平台，懂车更懂你。它会聪明地分析你的兴趣爱好，自动为你推荐喜欢的内容，看车选车买车就上懂车帝。懂车帝为您提供最新汽车视频，汽车碰撞视频，汽车评测视频，车展视频，美女车模视频，车祸视频，维修视频，漂移视频等'

// 视频播放器loading 懂车帝logo
export const ICON_VIDEO_PLAYER_LOADING =
  'https://sf1-ttcdn-tos.pstatp.com/obj/motor-img/f18f575471aab5f997767e7a9292405c'
